import React from 'react'
import './HeroBanner.scss'

const HeroBanner = ({
  title,
  text,
  backgroundImageUrl = null,
  mobileBackgroundImageUrl = null,
  button = null,
}) => {
  return (
    <div className="hero-banner themed-secondary">
      {/* these pixel widths (480/800) aren't correct. they symbolize mobile and not mobile.*/}
      {backgroundImageUrl && mobileBackgroundImageUrl && (
        <picture className="background">
          <source srcset={backgroundImageUrl} media="(min-width: 600px)" />
          <source
            srcset={mobileBackgroundImageUrl}
            media="(max-width: 599px)"
          />
          <img src={mobileBackgroundImageUrl} />
        </picture>
      )}

      <div className="container f">
        <div className="message">
          <h1 dangerouslySetInnerHTML={{ __html: title }} />
          <p dangerouslySetInnerHTML={{ __html: text }} />
          {button}
        </div>
      </div>
    </div>
  )
}

export default HeroBanner
